var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0384 21.1216C29.3313 20.8287 29.8061 20.8287 30.099 21.1216C30.3919 21.4145 30.3919 21.8894 30.099 22.1823L22.5087 29.7726C21.4259 30.8554 20.1222 31.4078 18.5975 31.4299C17.0949 31.4299 15.8022 30.8885 14.7195 29.8058C13.6367 28.723 13.0843 27.4193 13.0622 25.8946C13.0843 24.3699 13.6367 23.0662 14.7195 21.9834L23.5362 13.1667C24.3096 12.3933 25.2487 12.0066 26.3536 12.0066C27.5026 12.0066 28.4638 12.3933 29.2372 13.1667C30.0106 13.9401 30.3863 14.8903 30.3642 16.0172C30.3642 17.1221 29.9775 18.0612 29.2041 18.8346L21.7795 26.2592C21.2933 26.7453 20.6967 26.9884 19.9896 26.9884C19.3267 26.9884 18.7522 26.7453 18.266 26.2592C17.7799 25.7731 17.5258 25.1875 17.5037 24.5025C17.5037 23.7954 17.7468 23.1988 18.2329 22.7126L24.4311 16.5144C24.724 16.2215 25.1989 16.2215 25.4918 16.5144C25.7847 16.8073 25.7847 17.2822 25.4918 17.5751L19.2936 23.7733C19.0947 23.9722 18.9952 24.2042 18.9952 24.4693C19.0173 24.7566 19.1278 24.9997 19.3267 25.1985C19.5256 25.3974 19.7576 25.4969 20.0228 25.4969C20.2879 25.4969 20.5199 25.3974 20.7188 25.1985L28.1434 17.7739C28.6296 17.2878 28.8726 16.6912 28.8726 15.9841C28.8947 15.2991 28.6627 14.7135 28.1766 14.2273C27.6904 13.7412 27.0938 13.4981 26.3867 13.4981C25.6796 13.4981 25.083 13.7412 24.5969 14.2273L15.7801 23.0441C15.0067 23.8175 14.609 24.7677 14.5869 25.8946C14.609 27.0216 15.0067 27.9717 15.7801 28.7451C16.5535 29.5185 17.4926 29.9052 18.5975 29.9052C19.7244 29.8831 20.6746 29.4854 21.448 28.712L29.0384 21.1216Z",
    fill: "#027BFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.67139be06bc8095dd63ce649101b9108.svg";
export { ForwardRef as ReactComponent };